import { render } from "./ErrorServer.vue?vue&type=template&id=3095e404"
import script from "./ErrorServer.vue?vue&type=script&lang=js"
export * from "./ErrorServer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__